import { jsx as _jsx } from "react/jsx-runtime";
import NavigationLink from '@common/navigation/navigation-link';
import { EnumerableTextElements } from '@common/text-formattings/enumerable-text-elements';
export function UsersTableProfiles({ profiles }) {
    return (_jsx(EnumerableTextElements, { getKey: profile => `user-profile-${profile.id}`, getValue: profile => (_jsx(NavigationLink, { href: `/profiles/${profile.id}`, children: profile.title })), items: profiles }));
}
